import {DosageLimitsMatrix, Props} from '@/modules/drug-catalog/components/dosage-limits-matrix'
import {initializeDoseLimits} from '@/modules/drug-catalog/functions'
import {withFieldGroup} from '@cypro/ui/integrations/form'
import {useTranslate} from '@tolgee/react'

export const DosageLimitsFormMatrix = withFieldGroup({
  defaultValues: initializeDoseLimits(),
  props: {} as Omit<Props, 'renderCellContent'>,
  render: function Render({group, exclude, unit}) {
    const {t} = useTranslate('common')

    return (
      <DosageLimitsMatrix
        interactive
        bordered
        headerColor="fg.subtle"
        exclude={exclude}
        unit={unit}
        renderCellContent={({fieldKey, col}) => {
          return (
            <group.AppField name={fieldKey}>
              {field => (
                <field.NumberInput label={t(col.label)} hideLabel min={0} inputProps={{maxH: '8', fontSize: 'xs'}} />
              )}
            </group.AppField>
          )
        }}
      />
    )
  },
})
